'use client'
import { seo } from "@/utils/seo";
import Link from '@/components/LocaleLink';
import { useEffect } from "react";
import dynamic from 'next/dynamic';
import { useTranslation } from '@/contexts/TranslationContext';
const FamilyMemberForm = dynamic(() => import("@/components/familyMemberForm"),{ ssr: false });

const AddMember = () => {
    const { t } = useTranslation();

    useEffect(() => {
        seo(window.location.pathname);
    }, []);

    return (
        <div>
            <div className="app-content-body">
                <div className="bg-light lter b-b wrapper-md bgChange">
                    <h1 className="m-n font-thin h3">{t('members.addFamilyMember')}</h1>
                </div>

                <div className="wrapper-md">
                    <div className="section-content">
                        <div className="row">
                            <div className="col-3"></div>
                            <div className="col-6">
                                <div className="pull-right">
                                    <Link prefetch={false} href="/members/view" className="btn btn-default">{t('members.viewAllFamilyMembers')}</Link>
                                </div>
                            </div>
                        </div>
                        <br />
                        <FamilyMemberForm />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddMember;